import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Label, Button } from "../../../Components/Styled/Style";
import RightArrow from "../../../images/right-arrow.svg";
import { Icon } from "@iconify/react";
import FormControl from "../../FormControl/FormControl";
import { Wrapper } from "./OperatingLocations.styled";
import Heading from "../../Headings/MainHeading/Heading";
import Checkbox from "../../Checkbox/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import {
  add_city,
  add_town,
  delete_city,
  delete_town,
  get_cities,
  get_towns,
  setError,
  setSuccess,
  set_city,
  SET_ERROR,
  set_region,
  update_city,
  update_town,
} from "../../../Store/Reducers/Settings/actions";
import { ToastTopRight } from "../../Toasts/top-right";
import RadioInput from "../../RadioInput/RadioInput";

function OperatingLocations({ setOperatingModal }) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [cat, setCat] = useState(null);
  const [type, setType] = useState("region");
  const [popup_time, setPopupTime] = useState(0);
  const [data, setData] = useState({
    name: "",
    lat: "",
    lng: "",
    region: 1,
    city_id: "",
    town_id: "",
    active: true,
  });

  const { cities, towns, error, success } = useSelector(
    (state) => state.Settings
  );

  const confirm = () => {
    setOperatingModal(false);
  };

  const filteredCities = () => {
    return cities.filter((item) =>
      item.name.toLowerCase().match(search.toLowerCase())
    );
  };
  const filteredTowns = () => {
    return towns.filter((item) =>
      item.name.toLowerCase().match(search.toLowerCase())
    );
  };

  useEffect(() => {
    dispatch(get_cities({ regionId: data.region }));
    dispatch(set_region(data.region));
    setData({ ...data, town_id: "", city_id: "" });
  }, [data.region]);

  useEffect(() => {
    dispatch(get_towns({ cityId: data.city_id }));
    dispatch(set_city(data.city_id));
    setData({ ...data, town_id: "" });
  }, [data.city_id]);

  const save = () => {
    if (data.town_id !== "") {
      dispatch(update_town(data));
    } else if (data.city_id !== "") {
      dispatch(update_city(data));
    } else {
      alert("please select region!");
    }
  };
  const addNew = () => {
    if (type === "city") {
      dispatch(add_city(data));
    } else if (type === "town") {
      dispatch(add_town(data));
    } else {
      ToastTopRight.fire({
        icon: "error",
        title: "Please Select Town or City!",
      });
    }
  };

  const remove = () => {
    if (data.town_id !== "") {
      dispatch(delete_town(data));
    } else if (data.city_id !== "") {
      dispatch(delete_city(data));
    } else {
      alert("please select town or city!");
    }
  };

  useEffect(() => {
    let interval = null;

    if (popup_time > 0 && error?.msg !== "") {
      interval = setInterval(() => {
        console.log(`The current popup_time is ${popup_time}.`);
        setPopupTime(popup_time - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [popup_time, error]);

  useEffect(() => {
    if (error?.msg && error?.msg?.trim() !== "") {
      if (popup_time === 0) setPopupTime(5);
      ToastTopRight.fire({
        icon: "error",
        title: error?.msg,
      });
    }

    setTimeout(() => {
      dispatch(setError(""));
    }, 5000);
  }, [error]);

  useEffect(() => {
    if (success !== "") {
      // if (popup_time === 0) setPopupTime(5);
      ToastTopRight.fire({
        icon: "success",
        title: success,
      });

      setTimeout(() => {
        dispatch(setSuccess(""));
      }, 5000);
    }
  }, [success]);

  return (
    <Wrapper>
      {success}
      <Offcanvas.Header>
        <Offcanvas.Title>Set operating location</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <p className="descp">
          Select the regions, cities and towns in which you are going to operate{" "}
        </p>
        <Label color="#00273380">Search by name</Label>
        <div className="search-div">
          <Icon icon="fe:search" className="icon-label " size={17} />
          <input
            type="text"
            placeholder="Region > City > Town"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {/* {loading ? (
            <Spinner></Spinner>
          ) : ( */}
        <div className="main-body">
          <div className="categories-main">
            <div className="category-col">
              <div
                className={`item ${data.region === 1 ? "active" : ""}`}
                onClick={() => setData({ ...data, region: 1 })}
              >
                Region 1
                <img src={RightArrow} alt="right_icon" />
              </div>
              <div
                className={`item ${data.region === 2 ? "active" : ""}`}
                onClick={() => setData({ ...data, region: 2 })}
              >
                Region 2
                <img src={RightArrow} alt="right_icon" />
              </div>
            </div>
            <div className="category-col">
              {filteredCities().map((city, index) => {
                return (
                  <div
                    className={`item ${
                      data.city_id === city?.id ? "active" : ""
                    }`}
                    title="click to show towns"
                    onClick={() => {
                      setData({
                        ...data,
                        name: city.name,
                        city_id: city.id,
                        lat: city.lat,
                        lng: city.lng,
                        id: city.id,
                      });
                    }}
                  >
                    {city.name}
                    <img src={RightArrow} alt="right_icon" />
                  </div>
                );
              })}
            </div>
            <div className="category-col">
              {filteredTowns().map((town, index) => {
                return (
                  <div
                    className={`item ${
                      data.town_id === town?.id ? "active" : ""
                    }`}
                    title="click to show"
                    onClick={() => {
                      setData({
                        ...data,
                        name: town.name,
                        town_id: town.id,
                        lat: town.lat,
                        lng: town.lng,
                        id: town.id,
                      });
                    }}
                  >
                    {town.name}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="set-details">
            <Heading text={"Set details"} />
            <FormControl
              input={true}
              placeholder={"Town name"}
              labelValue={"Name"}
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
            <FormControl
              input={true}
              placeholder={"-2.1232131"}
              labelValue={"Longitude"}
              value={data.lng}
              onChange={(e) => setData({ ...data, lng: e.target.value })}
            />
            <FormControl
              input={true}
              placeholder={"34.4211123"}
              labelValue={"Latitude"}
              value={data.lat}
              onChange={(e) => setData({ ...data, lat: e.target.value })}
            />
            <div className="mt-2">
              <FormControl
                toggle={true}
                labelValue="Active"
                checked={data.active}
                onChange={() => setData({ ...data, active: !data.active })}
              />
            </div>
            {type}
            <div className="mt-2 d-flex justify-content-between">
              <RadioInput
                title="Region"
                name="rating-radio"
                checked={type === "region" && true}
                onChange={() => setType("region")}
              />

              <RadioInput
                title="City"
                name="rating-radio"
                checked={type === "city" && true}
                onChange={() => setType("city")}
              />

              <RadioInput
                title="Town"
                name="rating-radio"
                checked={type === "town" && true}
                onChange={() => setType("town")}
              />
            </div>
            <div className="buttons d-flex justify-content-between">
              <Button className="delete" onClick={remove}>
                <Icon icon="ci:trash-full" /> Delete
              </Button>
              <Button className="save" onClick={save}>
                Save
              </Button>
            </div>
            <div className="d-flex justify-content-center">
              <Button className="add-new" onClick={addNew}>
                Add New
              </Button>
            </div>
          </div>
        </div>

        {/* )} */}
        {/* <div className="end mt-3">
          <Button
            width="150px"
            onClick={confirm}
            // disabled={!cat ? true : false}
          >
            Confirm
          </Button>
        </div> */}
      </Offcanvas.Body>
    </Wrapper>
  );
}

export default OperatingLocations;
